const SUPPORTED_LOCALES = ["en", "ja"];
const DEFAULT_LOCALE = "ja";

export function getLocaleFromQuery() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;

  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang");

  return SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
}